import { z } from 'zod';

export const FiscalSetupSuggestionSchema = z
  .object({
    nbsCode: z.string(),
    cClassTrib: z.string(),
    cIndOp: z.string(),
    confidence: z.number().min(0).max(1),
    reason: z.string(),
  })
  .strict();

export type FiscalSetupSuggestion = z.infer<typeof FiscalSetupSuggestionSchema>;

export const FISCAL_SETUP_SUGGESTION_JSON_SCHEMA: Record<string, unknown> = {
  type: 'object',
  properties: {
    nbsCode: { type: 'string' },
    cClassTrib: { type: 'string' },
    cIndOp: { type: 'string' },
    confidence: { type: 'number' },
    reason: { type: 'string' },
  },
  required: ['nbsCode', 'cClassTrib', 'cIndOp', 'confidence', 'reason'],
  additionalProperties: false,
};

export interface SuggestFiscalSetupRequest {
  serviceName: string;
  serviceDescription?: string | null;
  lc116Code?: string | null;
  fiscalServiceTypeId?: string | null;
}
